import { all, call, CallEffect, fork, put, PutEffect, takeEvery } from "redux-saga/effects";
import { ActionTypes } from "../../constants/ActionTypes";
import { ShowError, ShowSuccess } from "../../helper/Alert";
import { ISendLetter } from "../../interfaces/SendLetter";
import { CallHistoryMethodAction, goBack } from "connected-react-router";
import { onSendLetterSuccess } from "../actions";
import faMessage from "../../../src/lngProvider/locales/fa_IR.json";
import enMessage from "../../../src/lngProvider/locales/en_US.json";
import { defineMessages } from "react-intl";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";


// sendLetter
const sendLetterApi = async (sendLetterModel: ISendLetter) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post(`Letter/SendLetter`, sendLetterModel);
}

function* sendLetterRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, CallHistoryMethodAction<[]> | void, AxiosResponse<any>> {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        let result = yield call(sendLetterApi, action.payload);
        ShowSuccess("", messages["draft.SendLetter"]);
        yield put(onSendLetterSuccess({
            subject: action.payload.saveLetter.subject,
            letterCode: action.payload.saveLetter.letterCode,
            letterNumber: result.data
        }))
        return goBack();

    } catch (error) {
        ShowError("", error);
    }
}

export function* SendLetter() {
    yield takeEvery(ActionTypes.SEND_LETTER, sendLetterRequest);
}

export default function* rootSaga() {
    yield all([fork(SendLetter)]);
}
